export default "__VITE_ASSET__DjuCNWSQ__"